var render = function render(_c,_vm){return _c('th',{class:{
    'sorting': _vm.props.filters.sort !== _vm.field,
    'sorting_asc': _vm.props.filters.sort === _vm.props.field && _vm.props.filters.order === 'asc',
    'sorting_desc': _vm.props.filters.sort === _vm.props.field && _vm.props.filters.order === 'desc'
},attrs:{"width":_vm.props.width},on:{"click":function($event){_vm.listeners.click && _vm.listeners.click(_vm.props.field)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }